import { Box } from '@mui/material';
import {
  CRUD_COMPONENT_TYPE,
  CRUDComponent,
  useDataProvider,
} from '@ui-framework/index';
import { useParams } from 'react-router-dom';
import Grid2 from '@thirdparty-framework/mui/material/Grid';
import { ruleName, ruleResult, createdDateTime } from './accesorFuntions';
import tableschema from './schema/list.json';

function RuleResults() {
  const { id } = useParams();

  const provider =
    process.env.NODE_ENV === 'development' ? 'sxclServices' : 'default';
  const dataProvider = useDataProvider(provider);

  const listApiUrl = `${dataProvider.getApiUrl()}/sxcl/v1/service-jobs/${id}/events/rule-results`;

  const listProps = {
    columnPrimaryId: 'id',
    storeName: 'RuleResults',
    dataProvider,
    schema: tableschema,
    initialState: {
      showColumnFilters: false,
    },
    downloadApiUrl: null,
    listApiUrl,
    accessorFunctions: {
      ruleName,
      ruleResult,
      createdDateTime,
    },
    sortOrder: 'DESC',
    sortBy: 'createdDateTime',
  };

  return (
    <Box sx={{ p: 1 }}>
      <Grid2 sx={{ p: 1 }}>
        <CRUDComponent
          type={CRUD_COMPONENT_TYPE.ADVANCED_LIST}
          listProps={listProps}
        />
      </Grid2>
    </Box>
  );
}

export default RuleResults;
